import script from "./ViewFinancialTransactions.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewFinancialTransactions.vue?vue&type=script&setup=true&lang=js"

import "./ViewFinancialTransactions.vue?vue&type=style&index=0&id=4af43efe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4af43efe"]])

export default __exports__